export function pricingLineKey(line) {
  const rate = line?.rate_id || line?.pricing_item_id;
  if (line?.allocation_id) return `slot-${line.allocation_id}-rate-${rate}`;
  return `rate-${rate}`;
}

const SOURCE_ORDER = {
  space: 0,
  slot_attribute: 1,
  attribute: 2,
  experience: 3,
  overage: 4,
};

export function sortPricingLines(lines, nameOf = line => line.name) {
  return [...lines].sort((a, b) => {
    const sourceA =
      a.source?.source || a.source || a.live?.source || a.quoted?.source;
    const sourceB =
      b.source?.source || b.source || b.live?.source || b.quoted?.source;
    const sourceDiff =
      (SOURCE_ORDER[sourceA] ?? 99) - (SOURCE_ORDER[sourceB] ?? 99);
    if (sourceDiff !== 0) return sourceDiff;
    return String(nameOf(a) || '').localeCompare(String(nameOf(b) || ''));
  });
}

export function groupPricingRows(
  rows,
  { eventWideLabel, slotFallbackLabel } = {}
) {
  const slotGroups = new Map();
  const eventWide = [];

  (rows || []).forEach(row => {
    const line = row.live || row.quoted || row;
    const allocationId = line.allocation_id || line.allocationId;
    const slotLabel = line.slot_label || line.slotLabel;
    const startAt = line.start_at || line.startAt;
    if (allocationId) {
      const key = String(allocationId);
      if (!slotGroups.has(key)) {
        slotGroups.set(key, {
          key,
          label: slotLabel || slotFallbackLabel || 'Timeslot',
          startAt: startAt || null,
          rows: [],
        });
      }
      const group = slotGroups.get(key);
      group.rows.push(row);
      if (!group.startAt && startAt) group.startAt = startAt;
      if (slotLabel) group.label = slotLabel;
    } else {
      eventWide.push(row);
    }
  });

  const groups = [...slotGroups.values()]
    .sort((a, b) => {
      if (a.startAt && b.startAt)
        return new Date(a.startAt) - new Date(b.startAt);
      if (a.startAt) return -1;
      if (b.startAt) return 1;
      return String(a.label).localeCompare(String(b.label));
    })
    .map(group => ({
      ...group,
      rows: sortPricingLines(group.rows),
    }));

  if (eventWide.length) {
    groups.push({
      key: 'event-wide',
      label: eventWideLabel || 'Event-wide',
      startAt: null,
      rows: sortPricingLines(eventWide),
    });
  }

  return groups;
}
